<template>
    <div>
        <template v-if="hideModal && getCalls.length">
            <div
                class="notificationCall cursor-pointer"
                @click="toggleModal"
            >
                <i
                    class="fa fa-bell"
                    aria-hidden="true"
                />
            </div>
        </template>
        <template v-else>
            <div class="position-fixed top-0 right-0 bg-white w-25">
                <div
                    v-if="getCalls.length"
                    class="modal_call"
                >
                    <base-modal
                        @close="$emit('close')"
                    >
                        <div
                            slot="header"
                            class="h3 mb-0 p-3 header"
                        >
                            <span>Appel entrant</span>
                            <div>
                                <i
                                    class="fas fa-trash-alt cursor-pointer"
                                    @click="deleteCall"
                                />
                                <i
                                    class="fa fa-minus cursor-pointer pl-4"
                                    @click="toggleModal"
                                />
                            </div>
                        </div>

                        <div slot="body">
                            <div v-if="getCalls[0].idClient">
                                Vous avez un appel de {{ getCalls[0].dossier.prenom }} {{ getCalls[0].dossier.nom }} ({{ getCalls[0].phone }})<br> cegid : {{ getCalls[0].dossier.cegid }}
                            </div>
                            <div v-else>
                                Vous avez un appel du {{ getCalls[0].phone }}: Aucun dossier correspondant
                            </div>

                            <div
                                v-if="getCalls[0].dossierNumber > 1 "
                                class="font-weight-bold text-danger"
                            >
                                Attention : {{ getCalls[0].dossierNumber }} dossiers correspondent à ce client
                            </div>
                        </div>

                        <div
                            slot="footer"
                            class="p-0 px-3 d-flex justify-content-start"
                        >
                            <div v-if="getCalls[0].idClient">
                                <a
                                    class="text-white btn btn-success mt-3 mb-3 px-4"
                                    :href="processRedirectUrl()"
                                >
                                    Aller sur l'échange
                                </a>
                            </div>
                        </div>
                    </base-modal>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import BaseModal from "../templates/BaseModal"

    export default {
        name: "ClientCalls",

        components: { BaseModal },

        data: function () {
            return {
                hideModal: false,
            }
        },

        computed: {
            ...mapGetters(['getCalls'])
        },

        watch: {
            getCalls: function () {
                this.hideModal = false
            }
        },

        methods: {
            toggleModal: function() {
                this.hideModal = !this.hideModal
            },

            deleteCall: function() {
                this.$store.commit('popCall')
            },

            processRedirectUrl: function() {
                const { sujet_parent, sujet } = this.getCalls[0].sujet ? this.getCalls[0].sujet : {}
                let url = `/dossiers/${this.getCalls[0].idClient}/echange-client?newExchange=true`
                url += sujet_parent ? '&sujetParent='+sujet_parent : ''
                url += sujet ? '&sujet='+sujet : ''
                url += '&incoming=true'

                return url
            },
        }
    }
</script>

<style lang="scss">
    .notificationCall{
        position: fixed;
        right: 10px;
        top: 70px;
        z-index: 1040;
        border: 2px solid orangered;
        color: orangered;
        font-size: 24px;
        transition: all 0.3s ease;
        padding: 1px 10px;
        border-radius: 100%;
        &:hover{
            background: orangered;
            color: #fff;
        }
        i{
            animation: tilt-shaking 0.25s linear infinite;
        }
    }

    .modal_call{
        .modal-container{
            position: fixed;
            right: 0;
            top: 0;
            width:490px!important;
        }
        .header{
            width: 100%;
            display: flex;
            justify-content: space-between;
        }
        .modal-header{
            padding: 0 !important;
            .h3 {
                font-size: 1.35rem!important;
                margin-bottom: 0 !important;
            }
        }
        .modal-body{
            padding: 20px!important;
            font-size: 1rem!important;
        }
        .modal-footer{
            padding: 0 1rem!important;
        }
    }
    .position-fixed {
        z-index: 1030; /* todo: dynamique */
    }
    @keyframes tilt-shaking {
        0% { transform: rotate(0deg); }
        25% { transform: rotate(5deg); }
        50% { transform: rotate(0deg); }
        75% { transform: rotate(-5deg); }
        100% { transform: rotate(0deg); }
    }
</style>
